import 'large-small-dynamic-viewport-units-polyfill'
import 'semantic-ui-css/semantic.min.css'
import 'unfonts.css'
import './index.css'
import './semantic.overrides.css'

import { render } from 'preact'
import { App } from './app'
import { ErrorBoundary, Provider, TrackerProvider } from './store'
import AppStore from './store/AppStore'
// import 'preact/debug'

// Dev-only: unregister any service worker left behind by a previous
// `npm run preview` / `npm run build` and clear its caches. Without this,
// switching back to `npm run dev` can serve stale JS + strip COOP/COEP
// headers (breaks crossOriginIsolated, breaks SDK version checks).
//
// Scope: `serviceWorker.getRegistrations()` and `caches.keys()` are both
// origin-scoped by the browser. This only wipes SWs/caches for THIS app's
// origin (the dev server, typically localhost:4137); other PWAs on other
// origins are untouched. Clearing every cache on this origin is intentional
// — Workbox precache names change between builds and we want a clean slate.
if (import.meta.env.DEV && typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  void navigator.serviceWorker.getRegistrations().then((regs) => {
    for (const r of regs) void r.unregister()
  })
  if (typeof caches !== 'undefined') {
    void caches.keys().then((keys) => {
      for (const k of keys) void caches.delete(k)
    })
  }
}

const store = new AppStore()

render(
  <ErrorBoundary>
    <TrackerProvider ga={window.ga}>
      <Provider store={store}>
        <div id="data-capture-view"></div>
        <App />
      </Provider>
    </TrackerProvider>
  </ErrorBoundary>,
  document.getElementById('app') as HTMLElement
)
